export const RANDOMIZE = 'RANDOMIZE';
export const ACCUMULATE = 'ACCUMULATE';
export const NONE = 'NONE';
